import "./App.css";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../src/utils/AuthContext";
import { BasicLayout } from "./layouts/BasicLayout";
import { generateToken, messaging } from "./notifications/firebase";
import { onMessage } from "firebase/messaging";
import { getEncryptedStorageValue, getStorageValue } from "./utils/helper";
import NotificationsListAPI from "./utils/services/notifications.api";

function App() {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const refreshToken = getEncryptedStorageValue("refreshToken");
  const [isShowNotifications, setShowNotifications] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;
  const userId = getStorageValue("userId");

  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      const checkDate = new Date()?.toISOString();
      const response = await checkUnreadNotifications(userId, checkDate);
      if(response?.data?.message) {
        localStorage.removeItem("isClicked");
        localStorage.setItem("isReload", response?.data?.message);
        localStorage.setItem("notifications", response?.data?.message);
        setShowNotifications(response?.data?.message);
      }
    } 
  };

  useEffect(() => {
    generateToken();
    onMessage(messaging, (payload) => {
      localStorage.removeItem("isClicked");
      localStorage.setItem("isReload", true);
      localStorage.setItem("notifications", true);
      setShowNotifications(true);

      const notificationTitle = payload.data.title || "A2b";
      const notificationOptions = {
        body: payload.data?.body,
        icon: payload.data?.image,
      };

      if (!("Notification" in window)) {
        console.log("This browser does not support system notifications");
      } else if (Notification.permission === "granted") {
        const urlToOpen =
          window.location.origin +
            "/packagedetails/" +
            payload?.data?.jobId || window.location.origin + "/dashboard";
        var notification = new Notification(
          notificationTitle,
          notificationOptions
        );
        notification.onclick = function (event) {
          event.preventDefault();
          window.open(urlToOpen, "_blank");
          notification.close();
        };
      }
    });
    if (!isLoggedIn) {
      navigate("/");
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!refreshToken) {
      navigate("/")
    }
    // eslint-disable-next-line
  }, [refreshToken]);

  return (
    <div>
      <BasicLayout isShowNotifications={isShowNotifications}>
        <Outlet />
      </BasicLayout>
    </div>
  );
}

export default App;
